import { FC, ReactNode } from 'react';
import { VisuallyHidden } from '@mantine/core';
import { EMPTY_DISPLAY_PLACEHOLDER } from '@srm/ui/theme/forms';
import ToolTipTitle from '@atoms/ToolTipTitle/ToolTipTitle';
import './FieldWrapper.scss';
import clsx from 'clsx';

export interface IFieldWrapper {
    label?: ReactNode;
    inLineFormat: boolean;
    children: ReactNode;
    title?: string;
    wrapNewLines?: boolean;
    testid?: string;
    verticalBottomAlign?: boolean;
    isViewMode?: boolean;
    isEmpty?: boolean;
}

const FieldWrapper: FC<IFieldWrapper> = ({
    label,
    inLineFormat,
    children,
    title,
    wrapNewLines,
    testid,
    verticalBottomAlign,
    isViewMode = false,
    isEmpty = false,
}: IFieldWrapper) => {
    const className = inLineFormat ? ' field-wrapper-row' : ' field-wrapper-column';
    const classNameField = inLineFormat ? ' field-wrapper-field-row' : ' field-wrapper-field-column';
    const classNameWrapNewLines = wrapNewLines ? 'field-wrapper-field-multiline' : '';
    const classNameVerticalBottomAlign = verticalBottomAlign ? 'field-wrapper-field__verticalbottom' : '';
    return (
        <div
            className={clsx('field-wrapper', className, isViewMode && 'field-wrapper--view')}
            data-testid={testid ? `fieldwrapper-${testid}` : undefined}
        >
            {label && (
                <div className="field-wrapper-label">
                    {label}
                    <ToolTipTitle title={title} label={typeof label === 'string' ? label : undefined} />
                </div>
            )}
            <div
                className={clsx(
                    'field-wrapper-field',
                    classNameField,
                    classNameWrapNewLines,
                    classNameVerticalBottomAlign,
                )}
                data-testid={testid ? `field-${testid}` : undefined}
            >
                {isViewMode && isEmpty ? (
                    <>
                        <span className="field-wrapper-empty" aria-hidden>
                            {EMPTY_DISPLAY_PLACEHOLDER}
                        </span>
                        <VisuallyHidden>Не заполнено</VisuallyHidden>
                    </>
                ) : (
                    children
                )}
            </div>
        </div>
    );
};

export default FieldWrapper;
